import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdVetaCenterSourceOperators } from '@treadinc/horizon-api-spec';

import { VetaCenterSourceOperator } from '~hooks/useVetaCenter/models';

import { RARELY_CHANGED_DATA_STALE_TIME_IN_MS } from './constants';

const VETA_CENTER_SOURCE_OPERATORS_QUERY_KEY = 'vetaCenterSourceOperators';

export const getVetaCenterSourceOperatorsQueryKey = (companyId: string) => [
  VETA_CENTER_SOURCE_OPERATORS_QUERY_KEY,
  companyId,
];

export default function useVetaCenterSourceOperatorsQuery(
  companyId: string,
  siteId: string,
  isRequested: boolean,
) {
  const { data, isError, isFetching, refetch } = useQuery({
    queryKey: [...getVetaCenterSourceOperatorsQueryKey(companyId), siteId],
    queryFn: isRequested
      ? async ({ signal }) => {
          const response = await getV1CompaniesCompanyIdVetaCenterSourceOperators({
            path: { 'company-id': companyId },
            query: { site_id: siteId },
            signal,
          });

          return response.data.data.map(VetaCenterSourceOperator.parse);
        }
      : skipToken,
    retry: false,
    staleTime: RARELY_CHANGED_DATA_STALE_TIME_IN_MS,
  });

  return { isError, isFetching, operators: data ?? [], refetch };
}
